<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
      <v-list-item-title class="headline mt-6 mb-2 text-center">
        <br>
        <br>
        <br>
        <br>
        <br>
        <span style="color: #757575">Không có quyền truy cập</span>
          <br/>
          <v-btn
            color="#fff"
            class="error--text mt-2"
            @click="returnToHome()"
          >
              Trang chủ
          </v-btn>
      </v-list-item-title>

  </v-container>
</template>

<script>
import TokenService from '@/helpers/token'
export default {
    methods: {
      returnToHome() {
        let permissions = TokenService.getPermissions()
        if (permissions.includes('dashboard_read')) {
          this.$router.push('/dashboard')
        } else {
          this.$router.push('/contact/contact-list')
        }
      }
    }
}
</script>
